<template>
  <div>

    <b-card no-body >

      <b-card-body>
        <div class="d-flex justify-content-between  flex-wrap">
          <!-- Registar Empresa  -->

          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-button
                variant="gradient-primary"
                size="sm"
                class="mr-1"
                @click="traerDescuentos"
            >
              <font-awesome-icon icon="fa-solid fa-arrows-rotate" :spin="loading"/>
            </b-button>
            <b-button
                variant="gradient-primary"
                size="sm"
                v-b-modal.modal-importar
                class="mr-3"
                @click="descargarFile"
            >
              <span>
                <font-awesome-icon icon="fa-solid fa-file-excel"/>
              </span>
            </b-button>
            <label class="text-bold font-weight-bold font-medium-1">Mostrando {{ items.length }} registros</label>
          </b-form-group>

          <!-- filter -->
          <b-form-group
              label-for="filterInput"
              class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Buscar"
              />
              <b-input-group-append>
                <b-button
                    :disabled="!filter"
                    @click="filter = ''"
                >
                  Borrar
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

        </div>
      </b-card-body>

      <b-table
          hover
          responsive
          sticky-header="58vh"
          class="position-relative tablita"
          :items="items"
          :fields="fields"
          :filter="filter"
          :filter-included-fields="filterOn"
          :busy="loading"
          show-empty
          empty-text="No se encontraron datos en esta tabla."
          emptyFilteredText="No se encontraron datos con los parámetros ingresados."
      >
        <template #table-busy>
          <div class="text-center text-dark my-1">
            <b-spinner class="align-middle"></b-spinner> &emsp;
            <strong>Obteniendo datos...</strong>
          </div>
        </template>

      </b-table>

    </b-card>
  </div>
</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'
import { BBadge, BButton, BCard, BCardBody, BForm, BFormGroup, BFormInput, BFormSelect, BModal, BPagination, BSpinner, BTable, BRow, BCol, BDropdownDivider, BTooltip, BInputGroupAppend, BInputGroup, } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'

export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BFormInput,
    BModal,
    BForm,
    BCol,
    BRow,
    BDropdownDivider,
    BTooltip,
    BInputGroupAppend,
    BInputGroup,

  vSelect,

    ValidationProvider,
    ValidationObserver,
  },
  directives: {
  },
  data: () => ({
    loading: false,
    loading2: false,
    items: [],
    perPage: 10,
    pageOptions: [10, 15, 20],
    totalRows: 0,
    currentPage: 1,
    sortBy: 'id',
    sortDesc: false,
    sortDirection: 'asc',
    filter: null,
    filterOn: [],
    fields: [
      {
        key: 'fecha_hora',
        label: 'Fecha de Entrega',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'fecha_hora_cierre',
        label: 'Fecha de Descuento',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'dni',
        label: 'DNI',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'nombres',
        label: 'Nombres',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'cargo',
        label: 'cargo',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'area',
        label: 'área',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'codigo',
        label: 'Código',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'tipo',
        label: 'Tipo',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
      {
        key: 'observacion',
        label: 'Observación',
        sortable: true,
        tdClass: 'alinear-una-sola-linea',
      },
    ],
    status: [
      {
        0: 'Activo',
        1: 'Préstamo',
        2: 'Cerrado',
      },
      {
        0: 'light-success',
        1: 'light-warning',
        2: 'light-danger',
      }
    ],

    // validation rules
    required,
  }),
  computed: {},
  mounted() {
    this.traerDescuentos();
    localize("es");
  },

  //1	20/04/2022	5:00 p. m.	73749813	GUTIERREZ MURILLOS ANGIE	FRIO	ARANDANO	XII587	-				ACTIVO	70376061	APP

  methods: {
    traerDescuentos(){
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/elli/descuentos/'
      };

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data;
            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          });
    },

    descargarFile() {
      const yo = this
      const spd = yo.items

      if (spd.length > 0){
        const data = JSON.stringify(
            {
              "datas":spd,
            }
        )

        const config = {
          method: 'post',
          url: 'elli/descuentos/exportar/filter/',
          headers: {
            'Content-Type': 'application/json'
          },
          responseType: 'arraybuffer',
          data : data
        }

        axiosIns(config)
            .then(function (response) {
              if (response.status === 200) {

                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', "Reporte de Descuentos.xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();

                yo.$toast({
                      component: ToastificationContent,
                      props: {
                        title: 'Archivo creado',
                        icon: 'CheckIcon',
                        text: 'El archivo se creó satisfactoriamente.',
                        variant: 'success',
                      },
                    },
                    {
                      position: 'top-center',
                    })
              }
            })
            .catch(function (error) {
              console.log(error);
              yo.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Error en la creación del archivo',
                  icon: 'XIcon',
                  text: 'Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.',
                  variant: 'danger',
                },
              })
            })
            .finally(function () {
              yo.loading_exp = false
            });

      }else{
        yo.$toast(
            {
              component: ToastificationContent,
              props: {
                title: '¡Advertencia!',
                icon: 'AlertTriangleIcon',
                text: 'No se encuentran registros para exportar.',
                variant: 'warning',
              },
            },
            {
              position: 'top-center',
            }
        )
      }
    },

  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.alinear-una-sola-linea{
  white-space: nowrap!important;
}

.tablita{
  min-height: 58vh!important;
}

.tablita::-webkit-scrollbar {
  width: 1.35vh;
  height: 1.35vh;
}
.tablita::-webkit-scrollbar-track {
  background-color: rgba(171, 171, 171, 0.35);
  border-radius: 6px;
  position: absolute;
}
.tablita::-webkit-scrollbar-thumb {
  background-image: linear-gradient(47deg, #82868b, #9ca0a4);
  border-radius: 6px;
  position: absolute;
}

</style>
